import {trackAmplitudeEvent} from "@pg-mono/amplitude";
import {IPropertyDetailDTO} from "@pg-rp/homematch-tinder";

import {PropertyRpId} from "../../../types/ids";
import {IFavoriteListItemDTO} from "../../favorites/list/types/IFavoriteListItemDTO";
import {View} from "../../km_app/types/View";
import {IPropertyListItemDTO} from "../../properties/types/IPropertyListItemDTO";
import {getGtmEcommerceListDetailsByViewType} from "../gtm/ecommerce/common/get_gtm_ecommerce_list_details_by_view_type";
import {getAmplitudeFavoriteListProducts} from "./get_amplitude_favorite_list_products";
import {getAmplitudeViewItemListLocationByView} from "./get_amplitude_view_item_list_location_by_view";
import {getAmplitudeViewItemListProducts} from "./get_amplitude_view_item_list_products";

interface ITrackAmplitudeViewItemListParams {
    properties: (IPropertyListItemDTO | IPropertyDetailDTO)[];
    viewType: View;
    sentPropertyRpIds?: Set<PropertyRpId>;
}

interface ITrackAmplitudeFavoritesViewItemListParams {
    favorites: IFavoriteListItemDTO[];
    viewType: View.FAVORITE;
    sentPropertyRpIds?: Set<PropertyRpId>;
}

export const trackAmplitudeViewItemList = (params: ITrackAmplitudeViewItemListParams) => {
    const {properties, viewType, sentPropertyRpIds} = params;
    const {item_list_id, item_list_name} = getGtmEcommerceListDetailsByViewType(viewType);
    const location = getAmplitudeViewItemListLocationByView(viewType);
    const products = getAmplitudeViewItemListProducts({properties, viewType, sentPropertyRpIds});

    trackAmplitudeEvent("view_item_list", {
        item_list_id,
        item_list_name,
        products,
        ...(location ? {location} : {})
    });
};

export const trackAmplitudeFavoritesViewItemList = (params: ITrackAmplitudeFavoritesViewItemListParams) => {
    const {favorites, viewType, sentPropertyRpIds} = params;
    const {item_list_id, item_list_name} = getGtmEcommerceListDetailsByViewType(viewType);
    const location = getAmplitudeViewItemListLocationByView(viewType);

    trackAmplitudeEvent("view_item_list", {
        item_list_id,
        item_list_name,
        products: getAmplitudeFavoriteListProducts({favorites, viewType, sentPropertyRpIds}),
        ...(location ? {location} : {})
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";
import {IPropertyDetailDTO} from "@pg-rp/homematch-tinder";

import {PropertyRpId} from "../../../types/ids";
import {IFavoriteListItemDTO} from "../../favorites/list/types/IFavoriteListItemDTO";
import {View} from "../../km_app/types/View";
import {IPropertyListItemDTO} from "../../properties/types/IPropertyListItemDTO";
import {getGtmEcommerceListDetailsByViewType} from "../gtm/ecommerce/common/get_gtm_ecommerce_list_details_by_view_type";
import {getAmplitudeFavoriteListProducts} from "./get_amplitude_favorite_list_products";
import {getAmplitudeViewItemListLocationByView} from "./get_amplitude_view_item_list_location_by_view";
import {getAmplitudeViewItemListProducts} from "./get_amplitude_view_item_list_products";

interface ITrackAmplitudeViewItemListParams {
    properties: (IPropertyListItemDTO | IPropertyDetailDTO)[];
    viewType: View;
    sentPropertyRpIds?: Set<PropertyRpId>;
}

interface ITrackAmplitudeFavoritesViewItemListParams {
    favorites: IFavoriteListItemDTO[];
    viewType: View.FAVORITE;
    sentPropertyRpIds?: Set<PropertyRpId>;
}

export const trackAmplitudeViewItemList = (params: ITrackAmplitudeViewItemListParams) => {
    const {properties, viewType, sentPropertyRpIds} = params;
    const {item_list_id, item_list_name} = getGtmEcommerceListDetailsByViewType(viewType);
    const location = getAmplitudeViewItemListLocationByView(viewType);
    const products = getAmplitudeViewItemListProducts({properties, viewType, sentPropertyRpIds});

    trackAmplitudeEvent("view_item_list", {
        item_list_id,
        item_list_name,
        products,
        ...(location ? {location} : {})
    });
};

export const trackAmplitudeFavoritesViewItemList = (params: ITrackAmplitudeFavoritesViewItemListParams) => {
    const {favorites, viewType, sentPropertyRpIds} = params;
    const {item_list_id, item_list_name} = getGtmEcommerceListDetailsByViewType(viewType);
    const location = getAmplitudeViewItemListLocationByView(viewType);

    trackAmplitudeEvent("view_item_list", {
        item_list_id,
        item_list_name,
        products: getAmplitudeFavoriteListProducts({favorites, viewType, sentPropertyRpIds}),
        ...(location ? {location} : {})
    });
};
